import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { AddRolePageRoutingModule } from './add-role-routing.module';

import { AddRolePage } from './add-role.page';
import { BhInputComponentModule } from 'src/app/components/_core/bh-input/bh-input.component.module';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    AddRolePageRoutingModule,
    BhInputComponentModule,
    PipesModule,
  ],
  declarations: [AddRolePage]
})
export class AddRolePageModule {}
